import React from "react";
import { Box, Flex } from "@chakra-ui/core";
import Logo from "./Logo";

/** Specific header for the Landing page */

const LandingPageHeader = () => {
  return (
    <>
      <Box
        top="0"
        zIndex="4"
        left="0"
        right="0"
        width="100%"
        py="15px"
        background="rgba(252,252,252,252)"
      >
        <Flex align="center" justify="center" w="100%">
          <Box maxWidth="1490px" w="100%" h="100%">
            <Flex size="100%" align="center" justify="space-between">
              <Box
                minWidth="120px"
                as="a"
                d="block"
                href="/"
                aria-label="Paid.so logo |Back to homepage"
              >
                <Logo />
              </Box>
              <Flex mx="10px" align="center">
                {/* <Button
                size="xs"
                variant="ghost"
                cursor="pointer"
                _focus={{ outline: "none" }}
                _hover={{
                  background:"NONE",
                  color:"primary.500"
                }}
                color="primary.500"
              >
                BUSINESS
              </Button>
              <span style={{color:"#3E6866"}}>|</span>
              <Button
                size="xs"
                variant="ghost"
                cursor="pointer"
                _focus={{ outline: "none" }}
                _hover={{
                  background:"none",
                  color:"primary.500"
                }}
                color="primary.400"
              >
                DEVELOPERS
              </Button> */}
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default LandingPageHeader;
